var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var SearchListItem = /** @class */ (function () {
    function SearchListItem(obj, id) {
        this.value = '';
        this.type = '';
        this.codesAll = '';
        if (id) {
            this.id = id;
        }
        this.value = obj.value;
        this.type = obj.status;
        this.codesAll = obj.codes.join(', ');
    }
    return SearchListItem;
}());
export { SearchListItem };
var Search = /** @class */ (function (_super) {
    __extends(Search, _super);
    function Search(obj, id) {
        var _this = _super.call(this, obj, id) || this;
        _this.product_ids = _this.getCategoriesIds(obj.categories);
        _this.codes = _this.getCategoriesBarcodes(obj.categories);
        return _this;
    }
    Search.prototype.getCategoriesIds = function (rawCategories) {
        var categoriesIds = [];
        for (var _i = 0, rawCategories_1 = rawCategories; _i < rawCategories_1.length; _i++) {
            var cat = rawCategories_1[_i];
            if (cat.value) {
                categoriesIds.push(Number(cat.value));
            }
        }
        return categoriesIds;
    };
    Search.prototype.getCategoriesBarcodes = function (rawCategories) {
        var CategoriesBarcodes = [];
        for (var _i = 0, rawCategories_2 = rawCategories; _i < rawCategories_2.length; _i++) {
            var cat = rawCategories_2[_i];
            if (cat.barcode) {
                CategoriesBarcodes.push(cat.barcode);
            }
        }
        return CategoriesBarcodes;
    };
    Object.defineProperty(Search.prototype, "CategoriesFormatted", {
        get: function () {
            return this.product_ids;
        },
        enumerable: false,
        configurable: true
    });
    return Search;
}(SearchListItem));
export { Search };
export function createSearchListItem(obj, id) {
    return new SearchListItem(obj, id);
}
export function createSearch(obj, id) {
    return obj;
}
var SearchAdd = /** @class */ (function () {
    function SearchAdd() {
    }
    return SearchAdd;
}());
export { SearchAdd };
export function createUpdateSearch(obj, id) {
    var newSearch = {};
    newSearch.value = obj.value;
    newSearch.status = obj.status;
    newSearch.product_ids = [];
    newSearch.codes = [];
    for (var _i = 0, _a = obj.categories; _i < _a.length; _i++) {
        var item = _a[_i];
        if (Object.keys(item).length !== 0) {
            newSearch.product_ids.push(Number(item.value));
            newSearch.codes.push(item.barcode);
        }
    }
    return newSearch;
}
export function createSearches(rawSearches, id) {
    var searches = [];
    var rawSearchesData = rawSearches;
    for (var _i = 0, rawSearchesData_1 = rawSearchesData; _i < rawSearchesData_1.length; _i++) {
        var rawSearch = rawSearchesData_1[_i];
        var search = createSearchListItem(rawSearch.attributes, rawSearch.id);
        searches.push(search);
    }
    return searches;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/search/search.ts
// module id = 131
// module chunks = 0